export class Director {
    ID:number;
CLIENT_ID:number;
NAME:string;
POST:string;
IMAGE_URL:string;
SEQUENCE_NO:number;
STATUS:boolean;

}